import { SERVICE } from './constants'

export const SET_IS_LOADING = `${SERVICE}/SET_IS_LOADING`
